/**
 * @group Project
@summary Project domain

@remarks
This constant contains the project domain used for contact forms,
social links, and other communication channels.
 * @internal
 */
export const PROJECT_DOMAIN = 'phila.life';